import {FC} from 'react';
import {createRoot} from 'react-dom/client';
import {ThemeProvider} from 'styled-components';

import {IS_RUNNING_LOCALLY, WEBSITE_FRONTEND_URL} from '@shared/env';

import {CssReset} from '@shared_web/components/core/css_reset';
import {GlobalStyle} from '@shared_web/components/core/global_styles';

import {App} from '@website_frontend/components/app';
import {useAppTheme} from '@website_frontend/theme';

if (IS_RUNNING_LOCALLY) {
  new EventSource(`${WEBSITE_FRONTEND_URL}/esbuild`).onmessage = () => location.reload();
}

const Root: FC = () => {
  const theme = useAppTheme();
  return (
    <ThemeProvider theme={theme}>
      <CssReset />
      <App />
      <GlobalStyle />
    </ThemeProvider>
  );
};
Root.displayName = 'Root';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  if (container) {
    createRoot(container).render(<Root />);
  }
});
